import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

export const gaEvent = (
  category: string,
  action: string,
  label?: any,
  value?: any,
) => {
  trackCustomEvent({
    category,
    action,
    label: label || '',
    value: value || 0,
  })
}

// export const gaPage = (pathname: string): void => {
//   window.ga && ga('send', {
//     hitType: 'pageview',
//     page: pathname,
//   })
// }
